module.exports = __webpack_public_path__ + "img/H10026.70ef229a.png";